export default {
  computed: {
    toolsRoutes() {
      return {
        tools: {
          title: "Ferramentas"
        },
        "tools-webhook": {
          title: "Webhook (API e notificações)"
        },
        "tools-coproductions": {
          title: "Coproduções"
        },

        "tools-partners": {
          title: "Central de colaboradores"
        },

        "tools-partners-profile": {
          title: "Perfil de colaborador"
        },

        "tools-leadlist": {
          title: "Lead List"
        },

        "tools-email-marketing": {
          title: "Email marketing"
        },

        "tools-automations": {
          title: "Automações"
        },

        "tools-invoices": {
          title: "Notas fiscais"
        },

        "tools-member-area": {
          title: "Área de membros"
        },
        "tools-zoom": {
          title: "Zoom"
        },

        "tools-mec-certifications": {
          title: "Certificações MEC"
        },

        "tools-google-ads": {
          title: "Google Ads"
        },

        "tools-facebook-ads": {
          title: "Facebook Ads"
        },

        "tools-google-analytics": {
          title: "Google Analytics"
        },

        "tools-kwai-ads": {
          title: "Kwai Ads"
        }
      };
    }
  }
};
